var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M5.5 2.5H24.5V27.5H5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M24,3v24H6V3H24 M25,2H5v26h20V2L25,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M16.5 6L15 6 14 5 16.5 5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffae0",
    d: "M15,21.5c-1.379,0-2.5-1.122-2.5-2.5c0-0.212,0.081-0.928,0.623-3.333 c0.156-0.687,0.758-1.167,1.464-1.167h0.826c0.706,0,1.308,0.48,1.464,1.168C17.419,18.072,17.5,18.788,17.5,19 C17.5,20.378,16.379,21.5,15,21.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M15.413,15c0.471,0,0.872,0.32,0.975,0.778C16.971,18.351,17,18.913,17,19c0,1.103-0.897,2-2,2 s-2-0.897-2-2c0-0.087,0.029-0.649,0.611-3.222C13.715,15.32,14.116,15,14.587,15H15.413 M15.413,14h-0.827 c-0.935,0-1.744,0.646-1.951,1.558C12.35,16.821,12,18.476,12,19c0,1.657,1.343,3,3,3s3-1.343,3-3c0-0.524-0.35-2.179-0.636-3.442 C17.158,14.646,16.348,14,15.413,14L15.413,14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M15 18A1 1 0 1 0 15 20 1 1 0 1 0 15 18zM16.5 5A.5.5 0 1 0 16.5 6 .5.5 0 1 0 16.5 5zM16.5 4L15 4 14 3 16.5 3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M16.5 3A.5.5 0 1 0 16.5 4 .5.5 0 1 0 16.5 3zM13.5 5L15 5 16 4 13.5 4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M13.5 4A.5.5 0 1 0 13.5 5 .5.5 0 1 0 13.5 4zM16.5 8L15 8 14 7 16.5 7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M16.5 7A.5.5 0 1 0 16.5 8 .5.5 0 1 0 16.5 7zM13.5 7L15 7 16 6 13.5 6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M13.5 6A.5.5 0 1 0 13.5 7 .5.5 0 1 0 13.5 6zM16.5 10L15 10 14 9 16.5 9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M16.5 9A.5.5 0 1 0 16.5 10 .5.5 0 1 0 16.5 9zM13.5 9L15 9 16 8 13.5 8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M13.5 8A.5.5 0 1 0 13.5 9 .5.5 0 1 0 13.5 8zM16.5 12L15 12 14 11 16.5 11z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M16.5 11A.5.5 0 1 0 16.5 12 .5.5 0 1 0 16.5 11zM13.5 11L15 11 16 10 13.5 10z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M13.5 10A.5.5 0 1 0 13.5 11 .5.5 0 1 0 13.5 10zM16.5 14L15 14 14 13 16.5 13z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M16.5 13A0.5 0.5 0 1 0 16.5 14A0.5 0.5 0 1 0 16.5 13Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M13.5 13L15 13 16 12 13.5 12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M13.5 12A0.5 0.5 0 1 0 13.5 13A0.5 0.5 0 1 0 13.5 12Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.6ad51d22.svg";
export { ForwardRef as ReactComponent };